// extracted by mini-css-extract-plugin
var _1 = "TileButton_active__0edae";
var _2 = "TileButton_base__5b57f";
var _3 = "TileButton_description__6dd44";
var _4 = "TileButton_fluid__3a6ba";
var _5 = "TileButton_ghost__396fe";
var _6 = "TileButton_header__c650b";
var _7 = "TileButton_icon__82846";
var _8 = "TileButton_root__94987";
var _9 = "TileButton_stroke__cf718";
var _a = "TileButton_title__f08c0";
export { _1 as "active", _2 as "base", _3 as "description", _4 as "fluid", _5 as "ghost", _6 as "header", _7 as "icon", _8 as "root", _9 as "stroke", _a as "title" }
